module.exports = __webpack_public_path__ + "static/media/sap.534a1227.webm";